import { formatLocalDay } from '../lib/expiry.ts';

/** Centred "Approved {date}" divider under an original review. */
export function ApprovedLine({ at }: { at: string }) {
  return (
    <p className="my-3 text-center text-xs text-slate-400">{`Approved ${formatLocalDay(at)}`}</p>
  );
}
